var exports = {
  "m2": "RowFrame__ie8e7q",
  "Y9": "Header__6RYQHI",
  "Cp": "Cells__ukiNzt",
};

module.exports = exports;
